import { Row, Container, Carousel, CarouselItem } from "react-bootstrap"
import Footer from "../components/footer"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import React from "react"
import Header from "../components/header"
import GradAlumni from "../components/gradAlumni"
import PostDocAlumni from "../components/postDocAlumni"

export default function Alumni() {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter:  {sourceInstanceName: {eq: "alumni"} }) {
        edges {
          node {
            base
            childImageSharp {
    fluid(maxHeight: 500, quality: 100) {
      ...GatsbyImageSharpFluid
      ...GatsbyImageSharpFluidLimitPresentationSize
    }
            }
          }
        }
      }
    }
  `)
  console.log(data.allFile.edges)

  return (
    <div style={{ backgroundColor: "black" }}>
      <Header/>
      <div style={{ paddingTop: "20px" , height: "500px"}}>

        <Carousel style={{height: "500px"}}>
          {data.allFile.edges.map(image => (
            <CarouselItem>

              <Img className="imgCarousel"
                   fluid={image.node.childImageSharp.fluid}
                   style={{ alignSelf: "center" }}
                   alt={image.node.base.split(".")[0]}
              />

            </CarouselItem>
          ))}
        </Carousel>

      </div>

      <Container className="sectionPeople">
        <Row xs={1} md={1} lg={2} className="researchRow"
             style={{ margin: "50px" }}>
          <div style={{
            color: "floralWhite",
            display: "flex",
            flexDirection: "column",
            textAlign: "justify",
          }}>
            <h1 className="peopleTitle">Former Postdocs</h1>
            <PostDocAlumni/>

            <br/>
            <br/>
            <h1 className="peopleTitle">Former Graduate Students</h1>
            <GradAlumni/>
            <br/>
            <br/>
            <h1 className="peopleTitle">Former Research Technicians</h1>
            <span className="citationTitle" style={{ textAlign: "center" }}>
          Miyako Hirabayashi
          <br/>
          Virginie Courchet
          <br/>
          Courtney Benson
          <br/>
          Elizabeth Boutt
          <br/>
          Lisa Plummer
          <br/>
          Marie Rougié
          <br/>
          <br/>
          </span>

            <h1 className="peopleTitle"> Undergraduate Students</h1>
            <span className="citationTitle" style={{ textAlign: "center" }}>
          Valentine Andreu
          <br/>
          Chelsea Noble
          <br/>
          Dean Liou
          <br/>
          Amul Bathia
          <br/>
          Maxime Camo
          <br/>
          Petr Slivka
          <br/>
          Melody Lee
          <br/>
          Janet Berrios
          <br/>
          Hannah Bishop
          <br/>
          Rocky Cheung
          <br/>
          Eldon Peters
          <br/>
          Patrick-Olivier Rattis
          <br/>
          Laetitia Poccard-Chapuis
          <br/>
          Maëla Paul
          <br/>
          </span>
          </div>
        </Row>
      </Container>
      <Footer/>
    </div>
  )
}

